import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
    ui_icon_facebook: {
        height: "100%",
        width: "100%",
    },
}));
//# sourceMappingURL=ui_icon_facebook.css.js.map